import { CPFInput } from 'components/Inputs/CPFInput';
import { MaskedInput } from 'components/Inputs/MaskedInput';
import { PasswordInput } from 'components/Inputs/PasswordInput';
import { TextInput } from 'components/Inputs/TextInput';
import React from 'react';

import { Grid } from '@mui/material';

import { TutorAddressForm } from './AddressForm';

import { PasswordStrength } from 'components/PasswordStrength';
import { Button } from 'components/Button';
import { TutorTermsForm } from './TermsForm';
import {
  cpfValidator,
  emailValidator,
  requiredMessage,
} from 'schemas/validators';
import { useWatch } from 'react-hook-form';
import { passwordMatch } from 'util/auth';
import { useTutorUserRegistration } from 'context';

type Props = {
  update?: boolean;
  onNextClick: () => void;
};

export const TutorForm: React.FC<Props> = ({ children, onNextClick }) => {
  const { loading } = useTutorUserRegistration();

  return (
    <Grid p={2}>
      <Grid container item spacing={2}>
        <Grid item xs={12} md={8}>
          <TextInput
            name="name"
            id="name"
            label="NOME COMPLETO"
            required
            rules={{
              required: requiredMessage('Nome Completo'),
            }}
            disabled={loading}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <CPFInput
            name="cpf"
            id="cpf"
            label="CPF"
            required
            rules={{
              required: requiredMessage('CPF'),
              validate: cpfValidator,
            }}
            disabled={loading}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextInput
            required
            name="email"
            id="email"
            label="E-MAIL"
            rules={{
              required: requiredMessage('E-mail'),
              validate: emailValidator,
            }}
            disabled={loading}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <MaskedInput
            name="phone"
            id="phone"
            label="CELULAR"
            mask="(##) #####-####"
            rules={{
              required: requiredMessage('Celular'),
              minLength: {
                value: 11,
                message: 'Celular inválido.',
              },
            }}
            disabled={loading}
          />
        </Grid>

        <TutorAddressForm />

        <Password />
      </Grid>

      <Grid item container mt={3}>
        <Grid item xs={8}>
          <TutorTermsForm />
        </Grid>

        <Grid container justifyContent="flex-end" alignItems="flex-end">
          <Button onClick={onNextClick} loading={loading} disabled={loading}>
            PRÓXIMO
          </Button>

          {children}
        </Grid>
      </Grid>
    </Grid>
  );
};

const Password: React.FC = () => {
  const {
    loading,
    form: { control },
  } = useTutorUserRegistration();

  const password = useWatch({
    control,
    name: 'password',
  });

  return (
    <>
      <Grid item container spacing={2} xs={12}>
        <Grid item xs={6}>
          <PasswordInput
            required
            fullWidth
            id="password"
            name="password"
            label="Senha"
            rules={{
              required: requiredMessage('Senha'),
              validate: (value) =>
                passwordMatch(value).isValid
                  ? true
                  : 'A senha não atende aos requisitos abaixo',
            }}
            disabled={loading}
          />
        </Grid>

        <Grid item xs={6}>
          <PasswordInput
            required
            fullWidth
            id="password-confirmation"
            name="passwordConfirmation"
            label="Confirme sua senha"
            rules={{
              required: requiredMessage('Confirmação Senha'),
              validate: (value) =>
                value !== password ? 'As senhas não conferem.' : true,
            }}
            disabled={loading}
          />
        </Grid>
      </Grid>

      <Grid item xs={6}>
        <PasswordStrength />
      </Grid>
    </>
  );
};
